import React, { useContext, useState } from 'react';
import { Box } from '@mui/material';
import Navbar from '../../../../posnavbar/Navbar';
import { UserContext } from '../../../../../../App';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from '../../../hooks/SnackbarProvider';
import { getStoreCurrencySymbol } from '../../../../../../utils/currency';
import "./index.css";

export const DualScreenSettings = () => {
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();
  const { color } = useContext(UserContext);

  // Dynamic preview states
  const [screenType, setScreenType] = useState("touch"); // "touch" | "display"
  const [flowStep, setFlowStep] = useState("add-number"); // touch: idle, add-number, cart, payment, success | display: idle, cart-preview, scan-pay, success
  const [activeMedia, setActiveMedia] = useState("summer"); // "summer" | "breakfast" | "chef"
  const [customerDisplayEnabled, setCustomerDisplayEnabled] = useState(true);

  const handleMediaClick = (media, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setActiveMedia(media);
    showSnackbar("Feature Coming Soon", "info");
  };

  const handleFeatureClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    showSnackbar("Feature Coming Soon", "info");
  };
    const handleFeatureClickMobileNumber = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  // State switching functions
  const handleScreenTypeChange = (type) => {
    setScreenType(type);
    if (type === "touch") {
      setFlowStep("add-number");
    } else {
      setFlowStep("cart-preview");
    }
  };

  const handleScreenTypeClick = (type, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    handleScreenTypeChange(type);
  };

  const handleFlowStepClick = (step, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setFlowStep(step);
  };

  // Get active step title & description for the live preview header
  const getPreviewHeader = () => {
    if (screenType === "touch") {
      switch (flowStep) {
        case "idle":
          return { title: "Touch · Idle", desc: "Promo loop while no order is active" };
        case "add-number":
          return { title: "Touch · Add Number", desc: "Customer enters phone number or skips" };
        case "cart":
          return { title: "Touch · Cart", desc: "Live cart with loyalty status and totals" };
        case "payment":
          return { title: "Touch · Payment", desc: "Tips and payment options on the customer screen" };
        case "success":
          return { title: "Touch · Success", desc: "Payment confirmation and pickup message" };
        default:
          return { title: "Touch · Add Number", desc: "Customer enters phone number or skips" };
      }
    } else {
      switch (flowStep) {
        case "idle":
          return { title: "Display · Idle", desc: "Promo loop when there is no order" };
        case "cart-preview":
          return { title: "Display · Cart Preview", desc: "Read-only cart mirror while cashier builds the order" };
        case "scan-pay":
          return { title: "Display · Scan & Pay", desc: "QR Code and instructions displayed to scan and pay" };
        case "success":
          return { title: "Display · Success", desc: "Payment captured and order confirmation screen" };
        default:
          return { title: "Display · Cart Preview", desc: "Read-only cart mirror while cashier builds the order" };
      }
    }
  };

  const headerInfo = getPreviewHeader();

  // Helper component to render cart items list
  const renderCartItems = () => (
    <div className="ds-cart-order-items-list" data-testid="list-order-items">
      <div data-testid="card-order-item-1" className="ds-cart-order-item">
        <div className="ds-cart-item-thumb ds-cart-thumb-1"></div>
        <div className="ds-cart-item-details">
          <div className="ds-cart-item-row">
            <p className="ds-cart-item-name">N/A</p>
            <p className="ds-cart-item-price">{getStoreCurrencySymbol()}0</p>
          </div>
          <div className="ds-cart-item-meta">
            <span>Qty 0</span>
            <span>NA</span>
          </div>
        </div>
      </div>

      <div data-testid="card-order-item-2" className="ds-cart-order-item">
        <div className="ds-cart-item-thumb ds-cart-thumb-2"></div>
        <div className="ds-cart-item-details">
          <div className="ds-cart-item-row">
            <p className="ds-cart-item-name">NA</p>
            <p className="ds-cart-item-price">{getStoreCurrencySymbol()}0</p>
          </div>
          <div className="ds-cart-item-meta">
            <span>Qty 0</span>
            <span>With visual card</span>
          </div>
        </div>
      </div>

      <div data-testid="card-order-item-3" className="ds-cart-order-item">
        <div className="ds-cart-item-thumb ds-cart-thumb-3"></div>
        <div className="ds-cart-item-details">
          <div className="ds-cart-item-row">
            <p className="ds-cart-item-name">NA</p>
            <p className="ds-cart-item-price">{getStoreCurrencySymbol()}0</p>
          </div>
          <div className="ds-cart-item-meta">
            <span>Qty 0</span>
            <span>With visual card</span>
          </div>
        </div>
      </div>

      <div data-testid="card-order-item-4" className="ds-cart-order-item">
        <div className="ds-cart-item-thumb ds-cart-thumb-4"></div>
        <div className="ds-cart-item-details">
          <div className="ds-cart-item-row">
            <p className="ds-cart-item-name">NA</p>
            <p className="ds-cart-item-price">{getStoreCurrencySymbol()}0</p>
          </div>
          <div className="ds-cart-item-meta">
            <span>Qty 0</span>
            <span>With visual card</span>
          </div>
        </div>
      </div>

      <div data-testid="card-order-item-5" className="ds-cart-order-item">
        <div className="ds-cart-item-thumb ds-cart-thumb-5"></div>
        <div className="ds-cart-item-details">
          <div className="ds-cart-item-row">
            <p className="ds-cart-item-name">NA</p>
            <p className="ds-cart-item-price">{getStoreCurrencySymbol()}0</p>
          </div>
          <div className="ds-cart-item-meta">
            <span>Qty 0</span>
            <span>With visual card</span>
          </div>
        </div>
      </div>
    </div>
  );

  // Helper component to render price summary details
  const renderPriceBreakdown = () => (
    <div className="ds-price-breakdown-card ds-blur-bg">
      <div className="ds-price-row">
        <span>Subtotal</span>
        <span data-testid="text-subtotal">{getStoreCurrencySymbol()}0</span>
      </div>
      <div className="ds-price-row">
        <span>GST</span>
        <span>{getStoreCurrencySymbol()}0</span>
      </div>
      <div className="ds-price-row ds-total-row">
        <span>Total</span>
        <span data-testid="text-total">{getStoreCurrencySymbol()}0</span>
      </div>
    </div>
  );

  // Helper component to render welcome chef special promo card
  const renderPromoCard = () => {
    let bgGrad = '';
    let nowPlaying = '';
    let activeMediaFile = '';

    if (activeMedia === 'summer') {
      bgGrad = 'linear-gradient(140deg, #a855f7, #6366f1, #3b82f6)';
      nowPlaying = 'Now Playing · Video';
      activeMediaFile = 'summer_promo.mp4';
    } else if (activeMedia === 'breakfast') {
      bgGrad = 'linear-gradient(140deg, #f97316, #f59e0b)';
      nowPlaying = 'Now Playing · Image';
      activeMediaFile = 'breakfast_menu.jpg';
    } else {
      bgGrad = 'linear-gradient(140deg, #34d399, #14b8a6, #06b6d4)';
      nowPlaying = 'Now Playing · Image';
      activeMediaFile = 'chef_special_loop.jpg';
    }

    return (
      <div className="ds-promo-card-wrap">
        <div className="ds-promo-card-bg-gradient" style={{ background: bgGrad }}></div>
        <div className="ds-promo-card-bg-overlay"></div>
        <div className="ds-promo-card-content">
          <div className="ds-promo-now-playing-badge">{nowPlaying}</div>
          <h3 className="ds-promo-main-title">Seasonal offers, sharp photography, and clean brand messaging the customer can actually enjoy reading.</h3>
          <p className="ds-promo-sub-text">This is the true idle-state canvas for the secondary display, not just a placeholder panel.</p>
          <div className="ds-promo-media-info">
            <div>
              <p className="ds-promo-media-tag">Active media</p>
              <p className="ds-promo-media-name" data-testid="text-active-media">{activeMediaFile}</p>
            </div>
            <span className="ds-promo-media-resolution">1920 × 1080 playback</span>
          </div>
        </div>
      </div>
    );
  };

  // Simulated Monitor Body rendering logic based on active step
  const renderSimulatorBody = () => {
    if (screenType === "touch") {
      switch (flowStep) {
        case "idle":
          return (
            <div className="ds-simulated-grid ds-grid-cols-1">
              <div className="ds-simulated-sidebar-col">
                {renderPromoCard()}
                <div className="ds-bullet-cards-row">
                  <div className="ds-bullet-card">Fast, visually rich order mirroring</div>
                  <div className="ds-bullet-card">Self-serve number entry before ordering</div>
                  <div className="ds-bullet-card">On-screen tip and payment actions</div>
                </div>
              </div>

              <div className="ds-simulated-sidebar-col">
                <div className="ds-simulated-card ds-blur-bg">
                  <p className="ds-sidebar-label">Welcome</p>
                  <h4 className="ds-customer-name">Pallet Lynx Bistro</h4>
                  <p className="ds-customer-desc" style={{color: "rgba(255,255,255,0.65)"}}>
                    Orders appear instantly here as the cashier adds items, so the customer always sees a premium, trustworthy view.
                  </p>
                </div>
                <div className="ds-simulated-card ds-cyan-card ds-blur-bg">
                  <div className="ds-loyalty-prompt-badge">Loyalty Prompt</div>
                  <h4 className="ds-customer-name" style={{fontSize: "20px"}}>Add your number to earn rewards</h4>
                  <p className="ds-customer-desc">Touch customers can identify themselves before ordering and carry their profile straight into payment.</p>
                  <div className="ds-customer-action-bar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-qr-code ds-phone-icon" style={{width: "32px", height: "32px"}} aria-hidden="true">
                      <rect width="5" height="5" x="3" y="3" rx="1"></rect>
                      <rect width="5" height="5" x="16" y="3" rx="1"></rect>
                      <rect width="5" height="5" x="3" y="16" rx="1"></rect>
                      <path d="M21 16h-3a2 2 0 0 0-2 2v3"></path>
                      <path d="M21 21v.01"></path>
                      <path d="M12 7v3a2 2 0 0 1-2 2H7"></path>
                      <path d="M3 12h.01"></path>
                      <path d="M12 3h.01"></path>
                      <path d="M12 16v.01"></path>
                      <path d="M16 12h1"></path>
                      <path d="M21 12v.01"></path>
                      <path d="M12 21v-1"></path>
                    </svg>
                    <span className="ds-customer-action-prompt">Enter directly or scan to join the rewards program</span>
                  </div>
                </div>
              </div>
            </div>
          );

        case "add-number":
          return (
            <div className="ds-simulated-grid ds-grid-cols-2">
              <div className="ds-simulated-card ds-blur-bg">
                <div className="ds-step-header">
                  <div>
                    <p className="ds-step-num">Step 1 · Add Number</p>
                    <h3 className="ds-step-title">Enter mobile number</h3>
                    <p className="ds-step-desc">
                      Customers can type directly on the secondary screen, making the step feel intentional instead of interruptive.
                    </p>
                  </div>
                  <div className="ds-rewards-badge">
                    <p className="ds-rewards-tag">Rewards</p>
                    <p className="ds-rewards-val">0 pts today</p>
                  </div>
                </div>
                
                <div className="ds-number-input-preview">
                  <p className="ds-number-input-label">Mobile number</p>
                  <p className="ds-number-input-val" data-testid="text-phone-preview">98765 43210</p>
                </div>
                
                <div className="ds-keypad-grid" data-testid="grid-number-pad">
                  {["1", "2", "3", "4", "5", "6", "7", "8", "9", "Skip", "0", "⌫"].map((key) => {
                    let testId = `button-keypad-${key}`;
                    if (key === "Skip") testId = "button-keypad-skip";
                    if (key === "⌫") testId = "button-keypad-backspace";
                    return (
                      <button
                        key={key}
                        data-testid={testId}
                        className="ds-keypad-btn"
                        onClick={handleFeatureClickMobileNumber}
                      >
                        {key}
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="ds-simulated-sidebar-col">
                <div className="ds-simulated-card ds-blur-bg">
                  <p className="ds-sidebar-label">Why this step matters</p>
                  <div className="ds-sidebar-list">
                    <div className="ds-sidebar-item">Recognize repeat guests before payment starts.</div>
                    <div className="ds-sidebar-item">Reduce cashier questions because customers self-enter.</div>
                    <div className="ds-sidebar-item">Carry loyalty status straight into cart and payment.</div>
                  </div>
                </div>
                
                <div className="ds-simulated-card ds-emerald-card ds-blur-bg">
                  <p className="ds-rewards-tag-emerald">Recognized customer</p>
                  <h4 className="ds-customer-name">Priya Nair</h4>
                  <p className="ds-customer-desc">Gold member · 1 free dessert away from next reward</p>
                  <div className="ds-customer-action-bar">
                    <span className="ds-customer-action-prompt">Would you like to continue to cart?</span>
                    <button
                      className="ds-continue-btn"
                      data-testid="button-continue-after-number"
                     
                    >
                      Continue
                    </button>
                  </div>
                </div>
                
                <div className="ds-simulated-tip-card">
                  The preview is scrollable so larger keypad and customer profile sections behave like a real second-screen experience.
                </div>
              </div>
            </div>
          );

        case "cart":
          return (
            <div className="ds-simulated-grid ds-grid-cols-1">
              <div className="ds-simulated-sidebar-col">
                <div className="ds-simulated-card ds-blur-bg">
                  <div className="ds-step-header">
                    <div>
                      <p className="ds-step-num">Cart View</p>
                      <h3 className="ds-step-title">Counter Order #A214</h3>
                      <p className="ds-step-desc">The customer can review items, see rewards, and stay involved before payment.</p>
                    </div>
                    <div className="ds-rewards-badge" style={{backgroundColor: "rgba(255,255,255,0.1)", borderColor: "rgba(255,255,255,0.1)"}}>
                      <p className="ds-rewards-tag">Preparing</p>
                      <p className="ds-rewards-val">0 mins</p>
                    </div>
                  </div>

                  <div className="ds-cart-linked-loyalty-banner">
                    <div>
                      <p className="ds-loyalty-linked-title">NA · NA</p>
                      <p className="ds-loyalty-linked-desc">NA</p>
                    </div>
                    <div className="ds-loyalty-linked-badge">Linked</div>
                  </div>

                  {renderCartItems()}
                </div>

                {renderPriceBreakdown()}
              </div>

              <div className="ds-simulated-sidebar-col">
                {renderPriceBreakdown()}
                <div className="ds-simulated-card ds-blur-bg">
                  <p className="ds-sidebar-label">Customer context</p>
                  <div className="ds-sidebar-list">
                    <div className="ds-sidebar-item">Guest can verify every line item before payment begins.</div>
                    <div className="ds-sidebar-item">Totals remain pinned to a separate card so scrolling the order feels natural.</div>
                  </div>
                </div>
              </div>
            </div>
          );

        case "payment":
          return (
            <div className="ds-simulated-grid ds-grid-cols-2">
              <div className="ds-simulated-card ds-blur-bg">
                <div className="ds-step-header">
                  <div>
                    <p className="ds-step-num">Payment Flow</p>
                    <h3 className="ds-step-title">Customer selects how to pay</h3>
                    <p className="ds-step-desc">On a touch display, the guest can choose a tip, review total, and tap a payment option directly.</p>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-wallet ds-wallet-icon" aria-hidden="true">
                    <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path>
                    <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
                  </svg>
                </div>

                <div className="ds-payment-methods-grid" data-testid="grid-payment-methods">
                  <button data-testid="button-payment-method-upi" className="ds-pay-method-btn ds-pay-method-btn-active">
                    <div className="ds-pay-method-header">
                      <p className="ds-pay-method-title">UPI</p>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-credit-card ds-pay-method-icon" aria-hidden="true">
                        <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                        <line x1="2" x2="22" y1="10" y2="10"></line>
                      </svg>
                    </div>
                    <p className="ds-pay-method-desc">Tap to pay by app</p>
                  </button>

                  <button data-testid="button-payment-method-card" className="ds-pay-method-btn ds-pay-method-btn-inactive">
                    <div className="ds-pay-method-header">
                      <p className="ds-pay-method-title">Card</p>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-credit-card ds-pay-method-icon" aria-hidden="true">
                        <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                        <line x1="2" x2="22" y1="10" y2="10"></line>
                      </svg>
                    </div>
                    <p className="ds-pay-method-desc">Insert or tap card</p>
                  </button>

                  <button data-testid="button-payment-method-wallet" className="ds-pay-method-btn ds-pay-method-btn-inactive">
                    <div className="ds-pay-method-header">
                      <p className="ds-pay-method-title">Wallet</p>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-credit-card ds-pay-method-icon" aria-hidden="true">
                        <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                        <line x1="2" x2="22" y1="10" y2="10"></line>
                      </svg>
                    </div>
                    <p className="ds-pay-method-desc">Fast guest checkout</p>
                  </button>
                </div>

                <div className="ds-simulated-card ds-blur-bg" style={{marginTop: "16px", padding: "16px"}}>
                  <p className="ds-sidebar-label" style={{marginBottom: "12px"}}>Tip selection</p>
                  <div className="ds-tips-selection-grid" data-testid="panel-tip-options">
                    <button data-testid="button-tip-5" className="ds-tip-btn ds-tip-btn-inactive">
                      <p className="ds-tip-percent">0%</p>
                      <p className="ds-tip-amount">{getStoreCurrencySymbol()}0</p>
                    </button>
                    <button data-testid="button-tip-10" className="ds-tip-btn ds-tip-btn-active">
                      <p className="ds-tip-percent">0%</p>
                      <p className="ds-tip-amount">{getStoreCurrencySymbol()}0</p>
                    </button>
                    <button data-testid="button-tip-15" className="ds-tip-btn ds-tip-btn-inactive">
                      <p className="ds-tip-percent">0%</p>
                      <p className="ds-tip-amount">{getStoreCurrencySymbol()}0</p>
                    </button>
                  </div>
                </div>
              </div>

              <div className="ds-simulated-sidebar-col">
                <div className="ds-price-breakdown-card ds-blur-bg">
                  <div className="ds-price-row">
                    <span>Subtotal</span>
                    <span data-testid="text-subtotal">{getStoreCurrencySymbol()}0</span>
                  </div>
                  <div className="ds-price-row">
                    <span>GST</span>
                    <span>{getStoreCurrencySymbol()}0</span>
                  </div>
                  <div className="ds-price-row">
                    <span>Suggested tip</span>
                    <span>{getStoreCurrencySymbol()}0</span>
                  </div>
                  <div className="ds-price-row ds-total-row">
                    <span>Total</span>
                    <span data-testid="text-total">{getStoreCurrencySymbol()}0</span>
                  </div>
                </div>

                <div className="ds-simulated-card ds-blur-bg">
                  <p className="ds-sidebar-label">Checkout notes</p>
                  <div className="ds-sidebar-list">
                    <div className="ds-sidebar-item">Touch payment can show method choices and optional tips directly on-screen.</div>
                    <div className="ds-sidebar-item">Cashier can still finalize payment on the POS after the customer chooses a method here.</div>
                  </div>
                </div>
              </div>
            </div>
          );

        case "success":
          return (
            <div className="ds-simulated-success-layout">
              <div className="ds-success-checkmark-wrap">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-check ds-success-check-svg" aria-hidden="true">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="m9 12 2 2 4-4"></path>
                </svg>
              </div>
              <p className="ds-success-badge-tag">Payment complete</p>
              <h3 className="ds-success-heading">Thank you, Priya</h3>
              <p className="ds-success-sub-desc">The touch display can confirm payment, show earned points, and hand off to pickup messaging.</p>

              <div className="ds-success-details-grid">
                <div className="ds-success-detail-box">
                  <p className="ds-success-detail-label">Paid</p>
                  <p className="ds-success-detail-val">{getStoreCurrencySymbol()}0</p>
                </div>
                <div className="ds-success-detail-box">
                  <p className="ds-success-detail-label">Order</p>
                  <p className="ds-success-detail-val">#0</p>
                </div>
                <div className="ds-success-detail-box">
                  <p className="ds-success-detail-label">Pickup</p>
                  <p className="ds-success-detail-val">0 mins</p>
                </div>
              </div>
            </div>
          );

        default:
          return null;
      }
    } else {
      // DISPLAY ONLY MODE PREVIEWS
      switch (flowStep) {
        case "idle":
          return (
            <div className="ds-simulated-grid ds-grid-cols-1">
              <div className="ds-simulated-sidebar-col">
                {renderPromoCard()}
                <div className="ds-bullet-cards-row">
                  <div className="ds-bullet-card">Fast, visually rich order mirroring</div>
                  <div className="ds-bullet-card">Read-only mirror for non-touch displays</div>
                  <div className="ds-bullet-card">Cashier-triggered QR payment state</div>
                </div>
              </div>

              <div className="ds-simulated-sidebar-col">
                <div className="ds-simulated-card ds-blur-bg">
                  <p className="ds-sidebar-label">Welcome</p>
                  <h4 className="ds-customer-name">Pallet Lynx Bistro</h4>
                  <p className="ds-customer-desc" style={{color: "rgba(255,255,255,0.65)"}}>
                    Orders appear instantly here as the cashier adds items, so the customer always sees a premium, trustworthy view.
                  </p>
                </div>
                <div className="ds-display-only-note-card">
                  Display-only mode avoids input prompts and stays focused on cart visibility and cashier-led payment.
                </div>
              </div>
            </div>
          );

        case "cart-preview":
          return (
            <div className="ds-simulated-grid ds-grid-cols-1">
              <div className="ds-simulated-sidebar-col">
                <div className="ds-simulated-card ds-blur-bg">
                  <div className="ds-step-header">
                    <div>
                      <p className="ds-step-num">Cart View</p>
                      <h3 className="ds-step-title">Counter Order #A214</h3>
                      <p className="ds-step-desc">This is a read-only mirror of the cart while the cashier manages checkout on the main POS.</p>
                    </div>
                    <div className="ds-rewards-badge" style={{backgroundColor: "rgba(255,255,255,0.1)", borderColor: "rgba(255,255,255,0.1)"}}>
                      <p className="ds-rewards-tag">Preparing</p>
                      <p className="ds-rewards-val">0 mins</p>
                    </div>
                  </div>

                  <div className="ds-display-read-only-notice-block">
                    Display-only mode keeps the screen read-only. When the cashier chooses a payment method, this view flips to a QR payment panel automatically.
                  </div>

                  {renderCartItems()}
                </div>

                {renderPriceBreakdown()}
              </div>

              <div className="ds-simulated-sidebar-col">
                {renderPriceBreakdown()}
                <div className="ds-display-only-note-card">
                  Display-only mode avoids input prompts and stays focused on cart visibility and cashier-led payment.
                </div>
              </div>
            </div>
          );

        case "scan-pay":
          return (
            <div className="ds-simulated-grid ds-scan-pay-layout">
              <div className="ds-simulated-card ds-blur-bg ds-payment-flow-card">
                <div className="ds-payment-flow-header">
                  <div>
                    <p className="ds-payment-flow-subtitle">Payment Flow</p>
                    <h3 className="ds-payment-flow-title">Cashier has triggered scan & pay</h3>
                    <p className="ds-payment-flow-desc">On a non-touch screen, the customer cannot enter details. They just see the QR code after the cashier chooses UPI or QR payment on the main POS.</p>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-wallet ds-payment-flow-wallet-icon" aria-hidden="true">
                    <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path>
                    <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
                  </svg>
                </div>

                <div className="ds-scan-pay-qr-container">
                  <div className="ds-scan-pay-qr-frame">
                    <svg width="176" height="176" viewBox="0 0 100 100" className="ds-qr-code-image ds-scan-pay-qr-code-svg">
                      <rect width="100" height="100" fill="white" />
                      <rect x="5" y="5" width="25" height="25" fill="black" />
                      <rect x="8" y="8" width="19" height="19" fill="white" />
                      <rect x="12" y="12" width="11" height="11" fill="black" />

                      <rect x="70" y="5" width="25" height="25" fill="black" />
                      <rect x="73" y="8" width="19" height="19" fill="white" />
                      <rect x="77" y="12" width="11" height="11" fill="black" />

                      <rect x="5" y="70" width="25" height="25" fill="black" />
                      <rect x="8" y="73" width="19" height="19" fill="white" />
                      <rect x="12" y="77" width="11" height="11" fill="black" />

                      <rect x="40" y="10" width="8" height="8" fill="black" />
                      <rect x="50" y="20" width="8" height="8" fill="black" />
                      <rect x="40" y="40" width="12" height="12" fill="black" />
                      <rect x="10" y="45" width="8" height="8" fill="black" />
                      <rect x="75" y="45" width="12" height="8" fill="black" />
                      <rect x="45" y="75" width="8" height="12" fill="black" />
                      <rect x="80" y="80" width="10" height="10" fill="black" />
                      <rect x="60" y="70" width="8" height="8" fill="black" />
                    </svg>
                  </div>
                  <p className="ds-scan-pay-qr-subtitle">Cashier selected UPI QR</p>
                  <h4 className="ds-scan-pay-qr-title">Scan and pay</h4>
                  <p className="ds-scan-pay-qr-desc">Since this screen is display-only, the customer simply scans the QR code. No phone number entry or on-screen taps are required.</p>
                  
                  <div className="ds-scan-pay-instruction-box">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-qr-code ds-scan-pay-mini-qr-icon" aria-hidden="true">
                      <rect width="5" height="5" x="3" y="3" rx="1"></rect>
                      <rect width="5" height="5" x="16" y="3" rx="1"></rect>
                      <rect width="5" height="5" x="3" y="16" rx="1"></rect>
                      <path d="M21 16h-3a2 2 0 0 0-2 2v3"></path>
                      <path d="M21 21v.01"></path>
                      <path d="M12 7v3a2 2 0 0 1-2 2H7"></path>
                      <path d="M3 12h.01"></path>
                      <path d="M12 3h.01"></path>
                      <path d="M12 16v.01"></path>
                      <path d="M16 12h1"></path>
                      <path d="M21 12v.01"></path>
                      <path d="M12 21v-1"></path>
                    </svg>
                    <div>
                      <p className="ds-instruction-title">Open any UPI app and scan</p>
                      <p className="ds-instruction-subtitle">The cashier controls method changes from the main POS.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="ds-simulated-sidebar-col ds-scan-pay-sidebar">
                <div className="ds-sidebar-price-breakdown">
                  <div className="ds-price-row">
                    <span>Subtotal</span>
                    <span data-testid="text-subtotal">{getStoreCurrencySymbol()}0</span>
                  </div>
                  <div className="ds-price-row">
                    <span>GST</span>
                    <span>{getStoreCurrencySymbol()}0</span>
                  </div>
                  <div className="ds-price-row ds-total-row">
                    <span>Total</span>
                    <span data-testid="text-total">{getStoreCurrencySymbol()}0</span>
                  </div>
                </div>

                <div className="ds-simulated-card ds-blur-bg ds-checkout-notes-card">
                  <p className="ds-sidebar-label">Checkout notes</p>
                  <div className="ds-sidebar-list ds-checkout-notes-list">
                    <div className="ds-sidebar-item ds-checkout-note-item">Display-only mode should never ask for input beyond scanning the QR code.</div>
                    <div className="ds-sidebar-item ds-checkout-note-item">If cashier switches to card or cash, this panel can change to a simple instruction state instead.</div>
                  </div>
                </div>
              </div>
            </div>
          );

        case "success":
          return (
            <div className="ds-simulated-success-layout">
              <div className="ds-success-checkmark-wrap">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-check ds-success-check-svg" aria-hidden="true">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="m9 12 2 2 4-4"></path>
                </svg>
              </div>
              <p className="ds-success-badge-tag">Payment complete</p>
              <h3 className="ds-success-heading">Payment Captured</h3>
              <p className="ds-success-sub-desc">The cashier screen will automatically update to confirm order creation and payment success status.</p>

              <div className="ds-success-details-grid">
                <div className="ds-success-detail-box">
                  <p className="ds-success-detail-label">Paid</p>
                  <p className="ds-success-detail-val">{getStoreCurrencySymbol()}0</p>
                </div>
                <div className="ds-success-detail-box">
                  <p className="ds-success-detail-label">Order</p>
                  <p className="ds-success-detail-val">NA</p>
                </div>
                <div className="ds-success-detail-box">
                  <p className="ds-success-detail-label">Pickup</p>
                  <p className="ds-success-detail-val">0 mins</p>
                </div>
              </div>
            </div>
          );

        default:
          return null;
      }
    }
  };

  // Get active step footer text & totals
  const getSimulatedFooter = () => {
    if (flowStep === "idle") {
      return { text: "Waiting for next order", price: `${getStoreCurrencySymbol()}0` };
    }
    if (flowStep === "success") {
      return { text: "Payment captured successfully", price: `${getStoreCurrencySymbol()}0` };
    }
    if (screenType === "touch" && flowStep === "add-number") {
      return { text: "Customer-facing screen is live", price: `${getStoreCurrencySymbol()}0` };
    }
    if (screenType === "display" && flowStep === "scan-pay") {
      return { text: "Cashier-triggered QR payment state is active", price: `${getStoreCurrencySymbol()}0` };
    }
    return { text: "Customer-facing screen is live", price: `${getStoreCurrencySymbol()}0` };
  };

  const footerInfo = getSimulatedFooter();
  let previewTitle = headerInfo.title;
  let previewDesc = headerInfo.desc;
  let statusBadgeText = "Screen Online";
  let statusBadgeClass = "ds-page-preview-status-badge";

  if (!customerDisplayEnabled) {
    previewTitle = "Display disabled";
    previewDesc = screenType === "touch" ? "Promo loop while no order is active" : "Promo loop when there is no order";
    statusBadgeText = "Screen Paused";
    statusBadgeClass = "ds-page-preview-status-badge ds-status-paused";
  }

  const monitorBgColor = '#040816';
  const glowStyle = 'radial-gradient(circle at top, rgba(99, 102, 241, 0.45), transparent 36%), radial-gradient(circle at bottom right, rgba(14, 165, 233, 0.2), transparent 28%)';

  return (
    <Navbar>
      <div className={`ds-page-container ${color === 'dark' ? 'ds-dark' : ''}`}>
        {/* Header Bar */}
        <div className="ds-page-header-sticky">
          <div className="ds-hdr-wrap">
            <div className="ds-hdr-left">
              <button
                data-testid="button-back"
                className="ds-hdr-back"
                onClick={() => navigate(-1)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-left h-5 w-5" aria-hidden="true">
                  <path d="m12 19-7-7 7-7"></path>
                  <path d="M19 12H5"></path>
                </svg>
              </button>
              <h1 className="ds-hdr-title">Customer Facing Display</h1>
            </div>
            <div className="ds-hdr-right">
              <span className="ds-hdr-toggle-label">Enable Customer Display</span>
              <button
                type="button"
                role="switch"
                aria-checked={customerDisplayEnabled}
                data-state={customerDisplayEnabled ? "checked" : "unchecked"}
                value="on"
                className="ds-hdr-switch"
                data-testid="switch-enable-customer-display"
                onClick={() => setCustomerDisplayEnabled(!customerDisplayEnabled)}
              >
                <span
                  data-state={customerDisplayEnabled ? "checked" : "unchecked"}
                  className="ds-hdr-switch-thumb"
                ></span>
              </button>
            </div>
          </div>
        </div>

        {/* Content Body */}
        <div className="ds-page-body-container">
          <div className="ds-page-layout-grid">
            
            {/* Left Column - Live Preview */}
            <div className="ds-page-left-column">
              <div className="ds-page-preview-panel">
                <div className="ds-page-preview-inner-screen">
                  <div className="ds-page-preview-header-bar">
                    <div>
                      <p className="ds-page-preview-subtitle">Live preview</p>
                      <h2 className="ds-page-preview-title" data-testid="text-preview-state">{previewTitle}</h2>
                      <p className="ds-page-preview-desc" data-testid="text-preview-description">{previewDesc}</p>
                    </div>
                    <div className={statusBadgeClass} data-testid="status-display-mode">
                      {statusBadgeText}
                    </div>
                  </div>

                  {/* Simulated secondary screen */}
                  <div className="ds-simulated-monitor" style={{ backgroundColor: monitorBgColor }}>
                    <div className="ds-simulated-glow-overlay" style={{ background: glowStyle }}></div>
                    <div className="ds-simulated-monitor-content">
                      {customerDisplayEnabled ? (
                        <>
                          <div className="ds-simulated-header">
                            <div className="ds-simulated-header-left">
                              <div className="ds-simulated-phone-icon-wrap">
                                {screenType === "touch" ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-smartphone ds-phone-icon"
                                    aria-hidden="true"
                                  >
                                    <rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
                                    <path d="M12 18h.01"></path>
                                  </svg>
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-monitor ds-phone-icon"
                                    aria-hidden="true"
                                  >
                                    <rect width="20" height="14" x="2" y="3" rx="2"></rect>
                                    <line x1="8" x2="16" y1="21" y2="21"></line>
                                    <line x1="12" x2="12" y1="17" y2="21"></line>
                                  </svg>
                                )}
                              </div>
                              <div>
                                <p className="ds-simulated-header-tag">Secondary screen</p>
                                <p className="ds-simulated-header-title">
                                  {screenType === "touch" ? "Touch flow with self-serve interaction" : "Display-only flow with cashier control"}
                                </p>
                              </div>
                            </div>
                            <div className="ds-simulated-header-badge">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-sparkles ds-sparkle-icon"
                                aria-hidden="true"
                              >
                                <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"></path>
                                <path d="M20 2v4"></path>
                                <path d="M22 4h-4"></path>
                                <circle cx="4" cy="20" r="2"></circle>
                              </svg>
                              Scroll enabled for realistic preview
                            </div>
                          </div>

                          {/* Simulated Screen Body */}
                          <div className="ds-simulated-body">
                            {renderSimulatorBody()}
                          </div>

                          {/* Simulated Screen Footer */}
                          <div className="ds-simulated-footer">
                            <span className="ds-simulated-footer-text">{footerInfo?.text}</span>
                            <span className="ds-simulated-footer-price">{footerInfo?.price}</span>
                          </div>
                        </>
                      ) : (
                        <div className="ds-display-off-container">
                          <div className="ds-display-off-icon-wrap">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-monitor ds-display-off-icon" aria-hidden="true">
                              <rect width="20" height="14" x="2" y="3" rx="2"></rect>
                              <line x1="8" x2="16" y1="21" y2="21"></line>
                              <line x1="12" x2="12" y1="17" y2="21"></line>
                            </svg>
                          </div>
                          <div className="ds-display-off-text-group">
                            <h3 className="ds-display-off-title">Customer display is off</h3>
                            <p className="ds-display-off-desc">Turn it back on to preview loyalty capture, cart review, payment, and confirmation.</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Flow Control Section */}
                <div className="ds-page-control-panel">
                  <div className="ds-page-control-row">
                    <button
                      data-testid="button-screen-type-touch"
                      className={`ds-control-btn ${screenType === "touch" ? "ds-control-btn-active" : "ds-control-btn-inactive"}`}
                      onClick={(e) => handleScreenTypeClick("touch", e)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-smartphone ds-btn-icon"
                        aria-hidden="true"
                      >
                        <rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
                        <path d="M12 18h.01"></path>
                      </svg>
                      <span>Touch Screen</span>
                    </button>
                    <button
                      data-testid="button-screen-type-display"
                      className={`ds-control-btn ${screenType === "display" ? "ds-control-btn-active" : "ds-control-btn-inactive"}`}
                      onClick={(e) => handleScreenTypeClick("display", e)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-monitor ds-btn-icon"
                        aria-hidden="true"
                      >
                        <rect width="20" height="14" x="2" y="3" rx="2" />
                        <line x1="8" x2="16" y1="21" y2="21" />
                        <line x1="12" x2="12" y1="17" y2="21" />
                      </svg>
                      <span>Display Only</span>
                    </button>
                  </div>

                  {/* Render conditionally on the basis of screenType */}
                  <div className="ds-page-control-row">
                    {screenType === "touch" ? (
                      <>
                        {["Idle", "Add Number", "Cart", "Payment", "Success"]?.map((step) => {
                          const val = step.toLowerCase().replace(" ", "-");
                          const testId = `button-flow-step-${val}`;
                          const isActive = flowStep === val;
                          return (
                            <button
                              key={step}
                              data-testid={testId}
                              className={`ds-flow-btn ${isActive ? "ds-flow-btn-active" : "ds-flow-btn-inactive"}`}
                              onClick={(e) => handleFlowStepClick(val, e)}
                            >
                              {step}
                            </button>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        {["Idle", "Cart Preview", "Scan & Pay", "Success"].map((step) => {
                          const val = step.toLowerCase().replace(" & ", "-").replace(" ", "-");
                          const testId = `button-flow-step-${val}`;
                          const isActive = flowStep === val;
                          return (
                            <button
                              key={step}
                              data-testid={testId}
                              className={`ds-flow-btn ${isActive ? "ds-flow-btn-active" : "ds-flow-btn-inactive"}`}
                              onClick={(e) => handleFlowStepClick(val, e)}
                            >
                              {step}
                            </button>
                          );
                        })}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Config Panel */}
            <div className="ds-page-right-column">
              {/* Interaction Model */}
              <div className="ds-config-card">
                <div className="ds-config-header">
                  <div className="ds-config-icon-box ds-indigo-light">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-panels-top-left ds-header-icon"
                      aria-hidden="true"
                    >
                      <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                      <path d="M3 9h18"></path>
                      <path d="M9 21V9"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="ds-config-title">Interaction Model</h3>
                    <p className="ds-config-subtitle">Build the right flow for a touch-enabled screen or a display-only screen.</p>
                  </div>
                </div>

                <div className="ds-list-container" data-testid="list-screen-types">
                  <button
                    data-testid="card-screen-type-touch"
                    className={`ds-screen-option-card ${screenType === "touch" ? "ds-screen-option-card-active" : "ds-screen-option-card-inactive"}`}
                    onClick={(e) => handleScreenTypeClick("touch", e)}
                  >
                    <div className="ds-option-icon-box ds-indigo-dark">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-smartphone ds-option-svg"
                        aria-hidden="true"
                      >
                        <rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
                        <path d="M12 18h.01"></path>
                      </svg>
                    </div>
                    <div className="ds-option-info">
                      <p className="ds-option-title-text">Touch Screen</p>
                      <p className="ds-option-desc-text">Customers can enter their number, review totals, choose tip, and tap through payment.</p>
                    </div>
                  </button>

                  <button
                    data-testid="card-screen-type-display"
                    className={`ds-screen-option-card ${screenType === "display" ? "ds-screen-option-card-active" : "ds-screen-option-card-inactive"}`}
                    onClick={(e) => handleScreenTypeClick("display", e)}
                  >
                    <div className="ds-option-icon-box ds-slate-light">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-monitor ds-option-svg"
                        aria-hidden="true"
                      >
                        <rect width="20" height="14" x="2" y="3" rx="2"></rect>
                        <line x1="8" x2="16" y1="21" y2="21"></line>
                        <line x1="12" x2="12" y1="17" y2="21"></line>
                      </svg>
                    </div>
                    <div className="ds-option-info">
                      <p className="ds-option-title-text">Display Only</p>
                      <p className="ds-option-desc-text">Cashier controls the journey while the customer only sees the cart and scan-to-pay state.</p>
                    </div>
                  </button>
                </div>
              </div>

              {/* Idle Screen Media */}
              <div className="ds-config-card">
                <div className="ds-config-header">
                  <div className="ds-config-icon-box ds-indigo-light">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-image ds-header-icon"
                      aria-hidden="true"
                    >
                      <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
                      <circle cx="9" cy="9" r="2"></circle>
                      <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="ds-config-title">Idle Screen Media</h3>
                    <p className="ds-config-subtitle">Pick what appears when the counter is waiting for the next order.</p>
                  </div>
                </div>

                <div className="ds-upload-dashed-card" onClick={handleFeatureClick}>
                  <div className="ds-upload-play-icon-wrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-circle-play ds-upload-svg"
                      aria-hidden="true"
                    >
                      <path d="M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z"></path>
                      <circle cx="12" cy="12" r="10"></circle>
                    </svg>
                  </div>
                  <p className="ds-upload-title-text">Upload Images or Video</p>
                  <p className="ds-upload-desc-text">1920 × 1080 recommended for customer-facing screens</p>
                </div>

                <div className="ds-list-container" data-testid="list-media-options">
                  <button
                    data-testid="button-media-summer-promo"
                    className={`ds-media-option-btn ${activeMedia === 'summer' ? 'ds-media-option-btn-active' : 'ds-media-option-btn-inactive'}`}
                    onClick={(e) => handleMediaClick('summer', e)}
                  >
                    <div className="ds-media-preview-thumb ds-grad-summer"></div>
                    <div className="ds-media-info">
                      <p className="ds-media-title-text">summer_promo.mp4</p>
                      <p className="ds-media-desc-text">Video loop for the idle or split-view panel</p>
                    </div>
                    {activeMedia === 'summer' && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-circle-check ds-check-svg"
                        aria-hidden="true"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                    )}
                  </button>

                  <button
                    data-testid="button-media-breakfast-menu"
                    className={`ds-media-option-btn ${activeMedia === 'breakfast' ? 'ds-media-option-btn-active' : 'ds-media-option-btn-inactive'}`}
                    onClick={(e) => handleMediaClick('breakfast', e)}
                  >
                    <div className="ds-media-preview-thumb ds-grad-breakfast"></div>
                    <div className="ds-media-info">
                      <p className="ds-media-title-text">breakfast_menu.jpg</p>
                      <p className="ds-media-desc-text">Image loop for the idle or split-view panel</p>
                    </div>
                    {activeMedia === 'breakfast' && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-circle-check ds-check-svg"
                        aria-hidden="true"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                    )}
                  </button>

                  <button
                    data-testid="button-media-chef-special"
                    className={`ds-media-option-btn ${activeMedia === 'chef' ? 'ds-media-option-btn-active' : 'ds-media-option-btn-inactive'}`}
                    onClick={(e) => handleMediaClick('chef', e)}
                  >
                    <div className="ds-media-preview-thumb ds-grad-chef"></div>
                    <div className="ds-media-info">
                      <p className="ds-media-title-text">chef_special_loop.jpg</p>
                      <p className="ds-media-desc-text">Image loop for the idle or split-view panel</p>
                    </div>
                    {activeMedia === 'chef' && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-circle-check ds-check-svg"
                        aria-hidden="true"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              {/* Display Options */}
              <div className="ds-config-card">
                <div className="ds-config-header">
                  <div className="ds-config-icon-box ds-indigo-light">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-panels-top-left ds-header-icon"
                      aria-hidden="true"
                    >
                      <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                      <path d="M3 9h18"></path>
                      <path d="M9 21V9"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="ds-config-title">Display Options</h3>
                    <p className="ds-config-subtitle">The preview updates instantly so you can compare both experiences.</p>
                  </div>
                </div>

                <div className="ds-list-container">
                  {[
                    { label: "Show Item Images", desc: "Display product visuals beside each item in the cart.", testId: "switch-show-item-images", checked: true },
                    { label: "Show Loyalty Prompt", desc: "Enable number entry and rewards prompts on touch-enabled screens.", testId: "switch-show-loyalty-prompt", checked: true },
                    { label: "Tipping Screen", desc: "Show tip options before final payment in touch mode.", testId: "switch-tipping-screen", checked: true },
                    { label: "Split View", desc: "Keep media or promos visible beside the cart or payment state.", testId: "switch-split-view", checked: false },
                  ].map((opt) => (
                    <div key={opt.label} className="ds-display-option-row" onClick={handleFeatureClick}>
                      <div>
                        <h4 className="ds-opt-title">{opt.label}</h4>
                        <p className="ds-opt-desc">{opt.desc}</p>
                      </div>
                      <button
                        type="button"
                        role="switch"
                        aria-checked={opt.checked ? "true" : "false"}
                        className={`ds-option-switch ${opt.checked ? "ds-option-switch-active" : "ds-option-switch-inactive"}`}
                        data-testid={opt.testId}
                      >
                        <span className={`ds-option-switch-thumb ${opt.checked ? "ds-option-switch-thumb-active" : "ds-option-switch-thumb-inactive"}`}></span>
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              {/* Flow Guidance */}
              <div className="ds-flow-guidance-card">
                <div className="ds-guidance-header">
                  <div className="ds-guidance-icon-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-star ds-star-svg"
                      aria-hidden="true"
                    >
                      <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="ds-guidance-title">Flow Guidance</h3>
                    <p className="ds-guidance-subtitle">Recommended behavior for the selected secondary screen type</p>
                  </div>
                </div>

                <div className="ds-guidance-list">
                  <div className="ds-guidance-item" data-testid="text-highlight-interaction">
                    Touch screen: start with add number, let guests review cart, then surface tip and payment choices directly on-screen.
                  </div>
                  <div className="ds-guidance-item" data-testid="text-highlight-images">
                    Visual item cards are enabled, which makes the customer cart more confidence-building and easier to scan.
                  </div>
                  <div className="ds-guidance-item" data-testid="text-highlight-layout">
                    Full-width mode gives the main cart and payment states the strongest visual priority.
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </Navbar>
  );
};

export default DualScreenSettings;
